module.exports = __webpack_public_path__ + "static/logo-c38bc68f0ab8c80e4b715719f3943e3e.png";